export const Config = {
  app: {
    maintenance: JSON.parse(
      process.env.REACT_APP_MAINTENANCE ||
        (window as any)?.config?.app?.maintenance ||
        "false"
    ),
    apiUnifiedCredentialsUrl:
      process.env.REACT_APP_UNIFIED_CREDENTIALS_URL ||
      (window as any)?.config?.app?.unified_credentials_url,
    apiPublicUnifiedCredentialsUrl:
      process.env.REACT_APP_PUBLIC_UNIFIED_CREDENTIALS_URL ||
      (window as any)?.config?.app?.public_unified_credentials_url,
      timeoutMS: process.env.REACT_APP_TIMEOUTMS ||
      (window as any)?.config?.app?.timeoutMS
  },
  environment: {
    name:
      process.env.REACT_APP_ENVIRONMENT_NAME ||
      (window as any)?.config?.environment?.name,
    code: process.env.REACT_APP_ENVIRONMENT_CODE ||
      (window as any)?.config?.environment?.code,
    color:
      process.env.REACT_APP_ENVIRONMENT_COLOR ||
      (window as any)?.config?.environment?.color,
  },
  auth_external: {
    domain:
      process.env.REACT_APP_EXTERNAL_USERS_AUTH_DOMAIN ||
      (window as any)?.config?.auth_external?.domain,
    clientId:
      process.env.REACT_APP_EXTERNAL_USERS_AUTH_CLIENT_ID ||
      (window as any)?.config?.auth_external?.clientId,
  },
  auth_internal: {
    domain:
      process.env.REACT_APP_INTERNAL_USERS_AUTH_DOMAIN ||
      (window as any)?.config?.auth_internal?.domain,
    clientId:
      process.env.REACT_APP_INTERNAL_USERS_AUTH_CLIENT_ID ||
      (window as any)?.config?.auth_internal?.clientId,
    scopes:
      process.env.REACT_APP_INTERNAL_USERS_SCOPES ||
      (window as any)?.config?.auth_internal?.scopes,
  },
  tracking: {
    gtm: process.env.REACT_APP_GTM || (window as any)?.config?.tracking?.gtm,
    walkme:
      process.env.REACT_APP_WALKME || (window as any)?.config?.tracking?.walkme,
  },
  v5: {
    serviceSite: process.env.REACT_APP_V5_SERVICE_SITE || (window as any)?.config?.v5?.serviceSite,
    serviceSiteLogoutUrl: process.env.REACT_APP_V5_SERVICE_SITE_LOGOUT_URL || (window as any)?.config?.v5?.serviceSiteLogoutUrl,
    employerSite: process.env.REACT_APP_V5_EMPLOYER_SITE || (window as any)?.config?.v5?.employerSite,
    employerSiteLogoutUrl: process.env.REACT_APP_V5_EMPLOYER_SITE_LOGOUT_URL || (window as any)?.config?.v5?.employerSiteLogoutUrl,
  },
};
